<template>
  <div class="coantiner">
    <div v-if="shoone">
      <div v-if="steps.length > 0" style="background-color: white">
        <div class="title">
          <div class="zhuan" v-if="trackingnumber">
            <p @click="copy(trackingnumber)">配送單號：{{ trackingnumber }}<img src="@/assets/image/copy.png" alt=""></p>
          </div>
          <div class="kefu" @click="kfu" v-if="shopkey.appCode === '1572677768'">
            <md-icon name="service" size="lg"></md-icon>
            <span>線上客服</span>
          </div>
        </div>
        <div id="time-line" style="padding: 0.2rem 0.2rem">
          <div class="item" v-for="item in steps" :key="item.index">
            <div class="item-index">{{ item.name }}</div>
            <div class="item-content">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <noth-modal v-else></noth-modal>
    </div>
    <div v-if="shotow">
      <div class="tplinir">
        <span>订单被拆分成以下包裹分别配送</span>
      </div>
      <div class="infoitem" v-for="(item, index) in list" :key="index">
        <div v-if="item.data">
          <p class="numtiennr">配送单号：{{ item.num }} <md-icon name="share" size="lg" style="margin-left:0.3rem"
              @click="copyitem(item.num)"></md-icon></p>
          <p class="context" @click="gonint(item)" v-if="item.data && item.data.length">{{ item.data[0].context }} </p>
          <p class="time" @click="gonint(item)" v-if="item.data && item.data.length">{{ item.data[0].time }}</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import NothModal from '../Modal/NothModal'
import { Toast, Icon } from 'mand-mobile'
export default {
  name: 'packLogin',
  components: {
    [Icon.name]: Icon,
    // eslint-disable-next-line vue/no-unused-components
    NothModal
  },
  data() {
    return {
      steps: [],
      trackingnumber: '',
      countruylist: [],
      shopkey: {},
      list: [],
      shoone: false,
      shotow: false,
      address: ''
    }
  },
  activated() {
    console.log(JSON.parse(localStorage.getItem('userinfoMobie')))
    Toast.loading('请稍等...')
    this.logisticsInfo()
    this.getCountry()
    this.shopkey = JSON.parse(localStorage.getItem("shopkey"))
  },
  methods: {
    copyitem(num) {
      const url = num;
      const oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.remove();
      Toast.succeed("複製成功");
    },
    gonint(item) {
      let info = item
      info.address = this.address
      this.$router.push({
        name: "Ordgetinfo",
        query: {
          des: JSON.stringify(info)
        }
      });
    },

    getCountry() {
      const par = {
        parentId: 0
      }
      this.http.APIASK(this.ports.country, 'get', par).then(res => {
        this.countruylist = res
      })
    },
    kfu() {
      console.log(this.countruylist)
      var v = this.countruylist.find((value, index, arr) => {
        return value.id == JSON.parse(localStorage.getItem('userinfoMobie')).disVo.id
      })
      console.log(v)
      window.location.href = 'https://ysftest4.qiyukf.com/client?k=2ae0e7640493795d063e35538c69a050&templateId=4474201&wp=1&sid=' + v.customerServiceId
    },
    copy(name) {
      const url = name
      const oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令1
      oInput.remove()
      Toast.succeed('複製成功')
    },
    logisticsInfo() {
      const par = {
        orderId: JSON.parse(this.$route.query.des).id
      }
      this.http.APIASK(this.ports.getlogisticsInfo, 'get', par).then(res => {
        Toast.hide()
        console.log('res', res)
        if (res.transLogistics) {
          this.shotow = true
          this.shoone = false
          this.list = res.transLogistics
          this.address == res.address
        } else if (res.detailsList.length > 0) {
          this.shotow = false
          this.shoone = true
          this.trackingnumber = res.trackingnumber
          let oy = {
            text: res.address,
            name: null
          }
          const result = res.detailsList.map(function (item) {
            // tslint:disable-next-line:radix
            return { name: item.eventscan, text: item.eventtime }
          })
          result.unshift(
            oy
          )
          console.log('result', result)
          this.steps = result
        } else {
          Toast.succeed('暫無物流資訊')
        }
      })
    }
  }
}
</script>

<style lang="less">
.coantiner {
  .title {
    height: 1rem;
    display: flex;
    align-items: center;
    font-size: 0.32rem;
    border-bottom: 1px solid #e2e2e2;
    padding: 0 0.3rem;
    justify-content: space-between;

    .zhuan {
      height: 100%;
      display: flex;
      align-items: center;

      img {
        width: 0.4rem;
        margin-left: 0.2rem;
      }
    }

    .kefu {
      display: flex;
      align-items: center;

      span {
        margin-left: 0.05rem;
      }
    }
  }

  .item {

    margin-left: 30px;
    /*用左边margin显示时间线*/
    width: calc(100% - 30px);
    /*因为左边部分用于显示时间线，所以右边部分减去30px*/
    height: auto;
    /*高度由内容决定*/
    position: relative;
    margin-bottom: 10px;
    cursor: pointer;
  }

  .item::before {
    content: "";
    width: 11px;
    height: 11px;
    border-radius: 100%;
    background-color: #91c2fc;
    position: absolute;
    left: -15px;
  }

  .item::after {
    content: "";
    width: 3px;
    height: calc(100% + 10px);
    /*加上10px是item底部的margin*/
    background-color: #91c2fc;
    position: absolute;
    top: 0;
    left: -11px;
  }

  .item-index {
    padding: 0.1rem 0;
    line-height: 12px;
    font-size: 0.32rem;
    text-align: left;
    position: relative;
    color: #656565;
    padding-left: 0.1rem;
  }

  .item-content {
    width: 100%;
    font-size: 0.3rem;
    text-align: left;
    padding-left: 0.1rem;
    height: auto;
    /*由内容决定*/
    position: relative;
    white-space: pre-wrap;
    /*保留空白符序列，但是正常地进行换行*/
    word-wrap: break-word;
    /*在长单词或 URL 地址内部进行换行*/
  }

  .item:hover::before {
    transform: scale3d(1.2, 1.2, 1);
    background-color: #569ffb;
  }

  .item:hover::after {
    transform: scale3d(1.1, 1, 1);
    background-color: #569ffb;
  }

  .item:hover .item-index {
    transform: scale3d(1.01, 1.01, 1);
    color: #343434;
  }
}

.tplinir {
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.32rem;
  color: #666666;
}

.infoitem {

  margin-bottom: 0.3rem;
  background-color: white;
}

.numtiennr {
  font-size: 0.32rem;
  color: #2f86f6;
  text-align: left;
  padding-top: 0.2rem;
  padding-left: 0.2rem;
}

.context {
  font-size: 0.32rem;
  text-align: left;
  padding-top: 0.2rem;
  padding-left: 0.2rem;
}

.time {
  font-size: 0.28rem;
  text-align: left;
  padding-top: 0.2rem;
  padding-left: 0.2rem;
  padding-bottom: 0.2rem;
  color: #666666;
}
</style>
